/* __next_internal_client_entry_do_not_use__ FullBleedCTA,FullBleedCTATrigger auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import cx from 'classnames';
import { invariant } from '~/utils/invariant';
import styles from './fullBleedCta.module.scss';
import { FullBleedCTAScopeContext, FullBleedCTATriggerContext, useIsInFullBleedCTA } from './fullBleedCta.utils';
/**
 * FullBleedCTA, combined with {@link FullBleedCTATrigger}, creates an element
 * that is completely clickable while being semantically correct. e.x. a card
 *
 * @example
 * <FullBleedCTA label="Defining Public Knowledge with Program Officer Patricia Hswe">
 *   <h2>Defining Public Knowledge with Program Officer Patricia Hswe</h2>
 *   <FullBleedCTATrigger>
 *     <Link href="/article/defining-public-knowledge-with-program-officer-patricia-hswe">
 *       Read the article
 *     </Link>
 *   </FullBleedCTATrigger>
 * </FullBleedCTA>
 */ export function FullBleedCTA(param) {
    let { as: Component = 'article', label, children, className, ...props } = param;
    return /*#__PURE__*/ _jsx(FullBleedCTAScopeContext.Provider, {
        value: true,
        children: /*#__PURE__*/ _jsx(Component, {
            "aria-label": label,
            className: cx(styles.root, className),
            ...props,
            children: children
        })
    });
}
/**
 * FullBleedCTATrigger wraps the clickable element within a FullBleedCTA. The
 * clickable area of this element will cover the entire FullBleedCTA.
 *
 * {@see FullBleedCTA}
 */ export function FullBleedCTATrigger(param) {
    let { children } = param;
    const isInFullBleedCTA = useIsInFullBleedCTA();
    invariant(isInFullBleedCTA, 'FullBleedCTATrigger must be a child of FullBleedCTA');
    return /*#__PURE__*/ _jsx(FullBleedCTATriggerContext.Provider, {
        value: true,
        children: /*#__PURE__*/ _jsx(Slot, {
            className: styles.trigger,
            children: children
        })
    });
}
